/* eslint-disable i18next/no-literal-string */
import { gql } from '@apollo/client'

const BOX_ORDER_FRAGMENT_V3 = gql`
  fragment upcomingBoxOrderFragmentV3 on Box {
    numberOfPouches
    id
    descriptor
    movedFromUndeliverableDeliveryDate
    address {
      id
      recipientName
      address1
      address2
      city
      postcode
      deliveryNotes
    }
    invoices {
      id
      issueDate
      corrective
      grossTotal
    }
    invoice {
      id
    }
    isOneOffBox
    isoDeliveryDate
    cutOffDate
    shippingDate
    isFreeBox
    isTrialBox
    isReplacementBox
    isNextEditableBox
    productSpacesFree
    discounts {
      applicableDiscountPart {
        discountBasis
        value
      }
    }
    consignment {
      id
      status
    }
    planPricePerDay
    order {
      id
      orderProducts {
        id
        nonPaymentReason
        quantity
        visibilityScope
        requiresPayment
        productVariant {
          id
          name
          productCollection {
            id
            name
            thumbnail {
              src
            }
          }
        }
      }
      planTotalPerDay
      planTotal
      surchargeTotal
      physicalProductsTotal
      deliveryFee
      discountTotal
      discountTotalPercentage
      totalPrice
    }
    amendable
    numberOfPouches
    meals {
      id
      flavour {
        id
        name
        thumbnail {
          src
        }
      }
      quantity
    }
  }
`

const NON_CORE_ORDER_FRAGMENT_V3 = gql`
  fragment nonCoreUpcomingOrderFragmentV3 on NonCoreOrder {
    id
    descriptor
    address {
      id
      recipientName
      address1
      address2
      city
      postcode
      deliveryNotes
    }
    invoice {
      id
      status
      grossPrice
      discountedPrice
      discountTotal
    }
    orderParts {
      deliverySurcharge
      smallOrderSurcharge
      orderProductsTotal
      consignment {
        id
        status
      }
      deliveryDate
      shippingDate
      orderProducts {
        id
        quantity
        productVariant {
          id
          name
          productCollection {
            id
            thumbnail {
              src
            }
          }
        }
      }
    }
  }
`

export { BOX_ORDER_FRAGMENT_V3, NON_CORE_ORDER_FRAGMENT_V3 }
